import { formatNumber } from "../utils/format.js";
import styles from "./EquipmentBreakdown.module.css";

const EQUIPMENT_LABELS = {
  barbell: "Barbell",
  dumbbell: "Dumbbell",
  cable: "Cable",
  machine: "Machine",
  bodyweight: "Bodyweight",
  band: "Band",
  "resistance band": "Band",
  kettlebell: "Kettlebell",
  plate: "Plate",
  "ez-bar": "EZ Bar",
  "ez bar": "EZ Bar",
  "smith machine": "Smith Machine",
  "assisted bodyweight": "Assisted",
  "weighted bodyweight": "Weighted BW",
  other: "Other",
};

function label(id) {
  return EQUIPMENT_LABELS[id] || id.replace(/_/g, " ").replace(/\b\w/g, (c) => c.toUpperCase());
}

export default function EquipmentBreakdown({ equipment }) {
  const items = equipment || [];
  const total = items.reduce((s, e) => s + e.setCount, 0);
  const max = items[0]?.setCount || 0;

  return (
    <div className={styles.panel}>
      <div className={styles.heading}>
        <span className={styles.headLabel}>Top equipment</span>
        {total > 0 && <span className={styles.total}>{formatNumber(total)} sets</span>}
      </div>

      {items.length === 0 ? (
        <div className={styles.empty}>No equipment data for this period</div>
      ) : (
        <div className={styles.list}>
          {items.map((eq) => {
            const barPct = max > 0 ? (eq.setCount / max) * 100 : 0;
            const pct = total > 0 ? Math.round((eq.setCount / total) * 100) : 0;
            return (
              <div key={eq.id} className={styles.row}>
                <span className={styles.name}>{label(eq.id)}</span>
                <div className={styles.barTrack}>
                  <div className={styles.barFill} style={{ width: `${barPct}%` }} />
                </div>
                <span className={styles.stat}>{formatNumber(eq.setCount)} · {pct}%</span>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}
